import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";
import { Input } from "./ui/input";
import { Textarea } from "./ui/textarea";
import { Button } from "./ui/button";
import { Label } from "./ui/label";
import { api, apiError } from "../lib/api";

export default function ContactForm() {
  const { t } = useTranslation();
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [sending, setSending] = useState(false);
  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const submit = async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      await api.post("/contact", form);
      toast.success(t("contact.sent"));
      setForm({ name: "", email: "", message: "" });
    } catch (err) {
      toast.error(apiError(err));
    } finally {
      setSending(false);
    }
  };

  return (
    <form onSubmit={submit} className="space-y-3" data-testid="contact-form">
      <h3 className="font-display text-lg font-semibold">{t("contact.title")}</h3>
      <p className="text-sm text-muted-foreground">{t("contact.sub")}</p>
      <div className="grid sm:grid-cols-2 gap-3">
        <div className="space-y-1"><Label htmlFor="c-name" className="text-xs">{t("contact.name")}</Label><Input id="c-name" value={form.name} onChange={(e) => set("name", e.target.value)} required data-testid="contact-name" /></div>
        <div className="space-y-1"><Label htmlFor="c-email" className="text-xs">{t("contact.email")}</Label><Input id="c-email" type="email" value={form.email} onChange={(e) => set("email", e.target.value)} required data-testid="contact-email" /></div>
      </div>
      <div className="space-y-1"><Label htmlFor="c-msg" className="text-xs">{t("contact.message")}</Label><Textarea id="c-msg" rows={3} value={form.message} onChange={(e) => set("message", e.target.value)} required data-testid="contact-message" /></div>
      <Button type="submit" disabled={sending} className="bg-[hsl(var(--primary))] text-white" data-testid="contact-send">{sending ? "…" : t("contact.send")}</Button>
    </form>
  );
}
